/* eslint-disable max-len */
import {defineMessages} from 'react-intl';

export default defineMessages({
	heading: {
		id: 'popups.countryConfirmRedirect.heading',
		defaultMessage: 'Leaving the country?',
	},
	cancel: {
		id: 'popups.countryConfirmRedirect.cancelButton',
		defaultMessage: 'Cancel',
	},
	continue: {
		id: 'popups.countryConfirmRedirect.continueButton',
		defaultMessage: 'Continue',
	},
	description: {
		id: 'popups.countryConfirmRedirect.description',
		defaultMessage:
			'We are committed to offering the best and quickest service possible. Based on your selected shipping destination, we will automatically transfer you to the official Casadei website nearest to that Country. The items in your shopping bag will not make the journey with you. Please note, styles and pricing may vary by region.',
	},
});
